import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

const baseURL = process.env.REACT_APP_BASE_URL
const loginURL = `${baseURL}/api/auth/issue-token`

export const login = createAsyncThunk(
  'auth/login',
  async ({ userName, password }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        loginURL,
        { userName, password },
        {
          headers: {
            'X-API-KEY': process.env.REACT_APP_API_AUTH_KEY,
            'Content-Type': 'application/json',
          },
        }
      )
      return response?.data
    } catch (error) {
      console.log('Full error object:', error)
      if (error.response) {
        console.log('Error response:', error.response)
        console.log('Error response data:', error.response.data)
      }

      if (
        error.response &&
        error.response.data.includes('is not currently available')
      ) {
        return rejectWithValue('Something went wrong, please try again.')
      }
      return rejectWithValue('Login failed, please check your credentials.')
    }
  }
)

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    accessToken: null,
    refreshToken: null,
    status: 'idle',
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.user = null
      state.accessToken = null
      state.refreshToken = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.status = 'loading'
        state.error = null
      })
      .addCase(login.fulfilled, (state, action) => {
        const { isSuccess, data } = action.payload || {}

        if (isSuccess) {
          state.status = 'succeeded'
          state.user = data.userName
          state.accessToken = data.accessToken
          state.refreshToken = data.refreshToken
        } else {
          state.status = 'failed'
          state.error = 'Login failed, please check your credentials.'
        }
      })
      .addCase(login.rejected, (state, action) => {
        state.status = 'failed'
        state.error =
          action.payload?.error?.customMessage ||
          'An unexpected error occurred.'
      })
      .addCase('RESET', () => ({
        user: null,
        accessToken: null,
        refreshToken: null,
        status: 'idle',
        error: null,
      }))
  },
})

export const { logout } = authSlice.actions
export default authSlice.reducer
